import React from "react";
import { Link, NavLink } from "react-router-dom";
import Logo from "../assets/Group 3.svg";
import phone from "../assets/Vector.svg";
import add from "../assets/Vector (1).svg";

import "./footer.scss";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer className="footer-area py-5 text-white">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="single-footer-widget">
              <img
                src={Logo}
                alt="Logo black"
                style={{ width: "60%", paddingBottom: "15px" }}
              />
              <p>
                <Link to="/" className="text-white text-decoration-none">
                  Unlock A Seamless Financial Journey With Our One -Stop
                  Consulting Hub
                </Link>
              </p>
              <div className="d-flex align-items-start mb-2">
                <img className="img me-3" src={phone} alt="Phone" />
                <div className="number">
                  <Link
                    to="/"
                    className="d-block text-white text-decoration-none"
                  >
                    +91 9599588308
                  </Link>
                  <Link
                    to="/"
                    className="d-block text-white text-decoration-none"
                  >
                    +91 9958302198
                  </Link>
                </div>
              </div>
              <div className="d-flex align-items-start">
                <img src={phone} alt="Email" className="img me-3" />
                <Link className="text-white text-decoration-none" to="/">
                  md@varrenyam.com
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="single-footer-widget">
              <h3>Quick Links</h3>
              <ul className="list-unstyled list">
                <li>
                  <NavLink
                    to="/about"
                    className=" text-decoration-none"
                    onClick={scrollToTop}
                  >
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ourTeam"
                    className=" text-decoration-none"
                    onClick={scrollToTop}
                  >
                    Our Team
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/"
                    className="text-decoration-none"
                    onClick={scrollToTop}
                  >
                    Expertise
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-footer-widget">
              <h3>Contact Us</h3>
              <ul className="footer-list list-unstyled">
                <li className="mb-3">
                  <div className="d-flex">
                    <div className="img me-3">
                      <img src={add} alt="Address" />
                    </div>
                    <div className="text">
                      <p className="mb-0 text-white">
                        Unit no 408, 409, Fourth floor, Enkay Centre, Wing A,
                        Plot no A, Vanijya Nikunj, Udyog Vihar, PHASE V, Gurgaon
                        122016 Haryana
                      </p>
                    </div>
                  </div>
                </li>
                <li className="enquiry">
                  <h5>Connect with us for free advisory services</h5>
                  <Link to="/bookConsultation">
                    <button
                      type="button"
                      className="btn w-100 mt-2"
                      onClick={scrollToTop}
                    >
                      Book A Free Consultant
                    </button>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="my-4 border-light" />

        <div className="text-center">
          <span>Copyright ©2024 All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
